export function tidyTitle(text: string): string {
  return text
    .replace(/(\d)\s%/g, '$1 %')
    .replace(/(\d)([–-])(\d)/g, '$1$2⁠$3')
    .replace(/\s([—–])\s/g, ' $1 ');
}
